<template>
  <BRow
    class="vh-100 px-0 bg-position d-flex justify-content-center"
    :style="{
      position: 'relative',
      overflow: 'hidden',
      backgroundImage: `url(${require('@/assets/images/background.jpg')})`,
      backgroundPosition: 'center top',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100%'
    }"
  >
    <div style="position: absolute; width: 100vw; transform: rotate(180deg); bottom: 0;">
      <svg viewBox="0 50 500 200">
        <path
          d="M 0 55 C 210 150 320 0 500 100 L 500 0 L 0 0"
          fill="#cbedff"
          opacity="0.6"
        />
        <path
          d="M 0 55 C 200 150 320 -25 500 50 L 500 0 L 0 0"
          fill="#00a5fe"
          opacity="0.8"
        />
        <path
          d="M 0 55 C 200 150 320 -50 500 50 L 500 0 L 0 0"
          fill="#006398"
          opacity="1"
        />
      </svg>
    </div>

    <BContainer
      class="h-100 d-flex justify-content-center align-items-center px-3 m-0"
    >
      <BCard
        class="rounded-lg"
      >
        <template #header>
          <h5 class="text-center mb-0">
            Inventory Transfer Management System
          </h5>
        </template>
        <BCardText class="d-flex justify-content-center">

          <ValidationObserver
            ref="signinForm"
            v-slot="{ handleSubmit }"
          >
            <form
              role="form"
              @submit.prevent="handleSubmit(onSignIn)"
            >
              <div
                class="rounded py-3 px-2"
                style="max-width: 350px; z-index: 1;"
              >
                <BRow>
                  <BCol
                    cols="12"
                  >
                    <BRow>
                      <BCol
                        cols="12"
                      >
                        <WVInput
                          v-model="credentials.username"
                          :disabled="state.busy"
                          :validation-attr="{
                            name: 'username',
                            vid: 'username',
                            rules: 'required'
                          }"
                          :form-group-attr="{
                            label: 'Username',
                            labelClass: 'font-weight-bolder',
                            class: 'mb-2'
                          }"
                          placeholder="enter username here"
                          autocomplete="off"
                          maxlength="50"
                          type="text"
                        />
                      </BCol>

                      <BCol
                        cols="12"
                      >
                        <WVInput
                          v-model="credentials.password"
                          :disabled="state.busy"
                          :validation-attr="{
                            name: 'password',
                            vid: 'password',
                            rules: 'required'
                          }"
                          :form-group-attr="{
                            label: 'Password',
                            labelClass: 'font-weight-bolder',
                            class: 'mb-2'
                          }"
                          placeholder="enter password here"
                          autocomplete="off"
                          maxlength="50"
                          type="password"
                        />
                      </BCol>

                    </BRow>
                  </BCol>
                </BRow>
                <BRow class="px-2 pt-3">

                  <BOverlay
                    class="col-12 px-1"
                    rounded
                    opacity="0.1"
                    spinner-variant="warning"
                    spinner-small
                    :show="state.local"
                  >
                    <BButton
                      size="sm"
                      type="submit"
                      class="w-100 font-weight-bolder"
                      variant="primary"
                      :disabled="state.busy"
                    >
                      Sign In
                    </BButton>
                  </BOverlay>

                </BRow>
              </div>

            </form>
          </ValidationObserver>
        </BCardText>
      </BCard>
    </BContainer>
  </BRow>
</template>

<script>
import { core } from '@/config/pluginInit'
import { Oauth2 } from 'universal-social-auth'

import url from '@/mixins/url'
import logos from '@/mixins/logos'

import { SSharedAuth, SSharedSSO } from '@/services/shared'

export default {
  name: 'SharedLogin',

  middleware: ['guest'],

  metaInfo: () => ({
    title: 'Sign In'
  }),

  mixins: [
    url,
    logos
  ],

  data: () => ({
    state: {
      busy: false,
      local: false,
      sso: false,
      visible_password: false
    },
    credentials: {
      username: '',
      password: ''
    },
    Oauth2
  }),

  computed: {

    companyLogo () {
      return this.transformToImageUrl(this.getCompany())
    },

    passwordType () {
      return this.state.visible_password ? 'text' : 'password'
    }

  },

  mounted () {
    core.index()
  },

  methods: {

    togglePassword () {
      this.state.visible_password = !this.state.visible_password
    },

    async saveAndGetCurrentUser (token) {
      this.$store.dispatch('auth/saveToken', token)
      this.$store.dispatch('auth/isUserLoggingOut', false)

      return new Promise((resolve, reject) => {
        SSharedAuth.getCurrentUser().then(
          ({ data }) => {
            this.$store.dispatch('auth/fetchUserSuccess', {
              id: data.id,
              email: data.email,
              role: data.role.code,
              role_name: data.role.name,
              username: data.role.username,
              name: data.name,
              location: data.location?.id || '',
              location_name: data.location?.location_name || '',
              location_code: data.location?.location_code || '',
              allow_in: data.location?.allow_in || 0,
              allow_out: data.location?.allow_out || 0,
              warehouse: data.location?.warehouse || '',
              prefix: data.location?.prefix || ''
            })
            const user = this.$store.getters['auth/user']
            this.$router.replace({
              name: user ? `${user.role}.dashboard` : 'dashboard'
            }, () => {
              resolve(data)
            })
          }
        ).catch(error => {
          this.$store.dispatch('auth/fetchUserFailure')
          reject(error)
        })
      })
    },

    async onSignIn () {
      await this.$refs.signinForm.validate().then(
        allFieldsAreValid => {
          if (allFieldsAreValid) {
            this.state.busy = this.state.local = true
            SSharedAuth.signIn(this.credentials).then(
              ({ data: { token } }) => {
                this.saveAndGetCurrentUser(token).finally(() => {
                  this.state.busy = this.state.local = false
                })
              }
            ).catch(() => {
              this.state.busy = this.state.local = false
            })
          }
        }
      )
    },

    async onSignInWithAljaySSO (event) {
      event.preventDefault()
      this.state.busy = this.state.sso = true
      this.$Oauth.authenticate('oauth2', this.Oauth2).then(
        authorized => {
          SSharedSSO.post(authorized).then(
            ({ data: { token } }) => {
              this.saveAndGetCurrentUser(token).finally(() => {
                this.state.busy = this.state.local = false
              })
            }
          ).catch(() => {
            this.state.busy = this.state.sso = false
          })
        }
      )
    }
  }
}
</script>

  <style scoped>

  .text-divider {
    margin: 2em 0;
    line-height: 0;
    text-align: center;
    color: gray;
    padding: 0px 5px;
  }
  .text-divider span {
    background-color: rgb(255, 255, 255);
    padding: 0 0.5em;
  }
  .text-divider:before {
    content: " ";
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px solid gray;
    border-bottom: 1px solid #f7f7f7;
  }
  .text-divider span:before  {
    content: "";
    display: block;
    margin-top: -3px;
  }
  .text-divider span:after  {
    display: block;
    margin-top: -3px;
  }

  .bg-position {
    background-color: #757783;
    background-size: 100vh auto !important;
    background-position: 50% center !important;
    height: 100vh !important;
  }

  @media screen and (orientation: landscape) {
    .bg-position {
      background-position: center 70% !important;
      background-size: 100% !important;
    }
  }

  @media screen and (orientation: landscape) and (max-width: 1024px) {
  }

  @media screen and (min-width: 1024px) {
    .bg-position {
      background-position: center 70% !important;
      background-size: 100% !important;
    }
  }
  </style>
